import { InvestmentPropsSchema, ExternalFundPropsSchema } from '../../graph-schemas/pevc-portfolio';
import type { NodeDefinition } from './base-crm';

export const PEVC_PORTFOLIO_NODES: Record<string, NodeDefinition> = {
  Investment: {
    type: 'Investment',
    schema: InvestmentPropsSchema,
    displayName: 'Investment',
    displayNamePlural: 'Investments',
    icon: 'TrendingUp',
    color: '#10b981',
    description: 'Actual investments made in portfolio companies (after deal closes)',
    synonyms: ['portfolio investment', 'equity stake', 'position'],
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'status', label: 'Status', type: 'select', required: true, picklistName: 'investment_status' },
      { key: 'investment_type', label: 'Investment Type', type: 'select', required: true, picklistName: 'investment_type' },
      { key: 'investment_date', label: 'Investment Date', type: 'date', required: true },
      { key: 'invested_amount', label: 'Invested Amount', type: 'number', required: true, format: 'currency' },
      { key: 'ownership_percentage', label: 'Ownership %', type: 'number' },
      { key: 'is_follow_on', label: 'Follow-on Investment', type: 'select', options: ['true', 'false'] },
    ],
    pmnEnabled: true,
    relationshipSections: [
      {
        sectionLabel: 'Portfolio Company',
        icon: 'Building2',
        edgeTypes: ['INVESTMENT_IN'],
        direction: 'outgoing',
        relatedNodeTypes: ['Organization'],
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Company', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'industry', headerName: 'Industry', flex: 1, minWidth: 120, source: 'node', editable: false },
        ],
      },
      {
        sectionLabel: 'Vehicle',
        icon: 'Landmark',
        edgeTypes: ['INVESTMENT_FROM'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Vehicle', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'status', headerName: 'Status', width: 120, source: 'node', editable: false },
        ],
      },
      {
        sectionLabel: 'Source Deal',
        icon: 'Handshake',
        edgeTypes: ['ORIGINATED_FROM'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Deal', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'stage', headerName: 'Stage', width: 120, source: 'node', editable: false },
        ],
      },
    ],
  },
  ExternalFund: {
    type: 'ExternalFund',
    schema: ExternalFundPropsSchema,
    displayName: 'External Fund',
    displayNamePlural: 'External Funds',
    icon: 'Briefcase',
    color: '#6366f1',
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'strategy', label: 'Strategy', type: 'select', picklistName: 'external_fund_strategy' },
      { key: 'vintage_year', label: 'Vintage Year', type: 'number' },
      { key: 'status', label: 'Status', type: 'select', required: true, picklistName: 'external_fund_status' },
    ],
    pmnEnabled: true,
    relationshipSections: [
      {
        sectionLabel: 'Manager',
        icon: 'Building2',
        edgeTypes: ['MANAGED_BY'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [{ field: 'name', headerName: 'Name', flex: 2, minWidth: 150, source: 'node', editable: false }],
      },
    ],
  },
};
